module.exports = __webpack_public_path__ + "assets/img/liucheng03.1698758c.jpg";